import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default class extends Controller {

    #swiperContainer;
    #selector = '#' + this.element.getAttribute('id') + ' .swiper.kundenreferenz-slider';
    #slides = this.element.querySelectorAll('.swiper-slide');
    #bullets;

    connect() {
        this.initBullets();
        this.swiperConfig();
        if (window.innerWidth < 550) {
            this.initKundenreferenzenMobile();
        }
    }

    initBullets() {
        document.addEventListener('swiperLoad', (event) => {

            this.#bullets = this.#bullets ? this.#bullets : this.element.querySelectorAll('.swiper-pagination-bullet');

            if (this.#slides.length > 0) {
                for (let i = 0; i < this.#slides.length; i++) {
                    let imagesrc = this.#slides[i].getAttribute('data-src'),
                        imagetag = document.createElement('img');

                    imagetag.src = imagesrc != null ? imagesrc : 'none';
                    if (this.#bullets[i]) {
                        this.#bullets[i].appendChild(imagetag);
                    }
                }
            }
        });
    }

    initKundenreferenzenMobile() {
        let clientCards = this.element.querySelectorAll('.client-card'),
            dropDownButton = this.element.querySelector('.dropdown'),
            dropDownMenu = this.element.querySelector('.dropdown-menu'),
            dropDownMenuPoints = this.element.querySelectorAll('.dropdown-menu-point');

        if (clientCards) {
            this.showFirstCard(clientCards);
        }

        if (dropDownButton && dropDownMenu) {
            this.toggleDropdown(dropDownButton, dropDownMenu, dropDownMenuPoints, clientCards);
        }

    }

    showFirstCard(clientCards) {
        clientCards[0].classList.add('show');
    }

    toggleDropdown(dropDownButton, dropDownMenu, dropDownMenuPoints, clientCards) {
        dropDownButton.addEventListener('click', function () {
            dropDownMenu.classList.toggle('show');

            if (dropDownMenu.classList.contains('show')) {
                dropDownMenuPoints.forEach((entry, index) => {
                    entry.addEventListener('click', function () {
                        dropDownMenu.classList.remove('show');
                        clientCards.forEach(card => {
                            card.classList.remove('show');
                        })
                        clientCards[index++].classList.add('show');
                    });
                });
            }
        });
    }

    swiperConfig() {
        this.#swiperContainer = new Swiper(this.#selector, {
            slidesPerView: 1,
            modules: [Pagination],
            loop: true,
            pagination: {
                el: '.referenzslider-pagination',
                clickable: true,
                type: 'bullets',
                bulletClass: 'swiper-pagination-bullet',
                dynamicBullets: true,
            },
            on: {
                init: function () {
                    const swiperLoadEvent = new CustomEvent('swiperLoad', {
                        detail: {
                            message: 'Swiper has loaded successfully',
                            time: new Date()
                        }
                    });

                    document.dispatchEvent(swiperLoadEvent);
                },
            },
        });
    }
}
